import { render, staticRenderFns } from "./TextViewer.vue.js?vue&type=template&id=7449406a&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextViewer.vue?vue&type=template&id=7449406a&scoped=true"
import script from "./TextViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextViewer.vue?vue&type=script&lang=js"
export * from "./TextViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7449406a",
  null
  
)

export default component.exports